/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable  dot-notation */
import React from 'react';
import { bool, string, object } from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';

import { ducks as checkoutDucks } from '../../../../../../../../../state/ducks/Checkout';
import { getDataDictionary } from '../../../../../../../../../state/ducks/App/App-Selectors';

const {
    common: {
        commonSelectors,
    },
    recipient: { recipientActions },
} = checkoutDucks;

// pass a prop into breadcrumb that signals that a subheading is active
const styles = (theme) => ({
    breadcrumbRow: {
        margin: '12px 0 -12px',
    },
    inactive: {
        color: theme.palette.colorNeutral60,
        fontWeight: '600',
        cursor: 'pointer',
        width: '100%',
        fontSize: '13px',
        display: 'flex',
        textDecoration: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
            verticalAlign: 'top',
            display: 'inline-block',
        },
    },
    active: {
        padding: '0px 18px 10px 6px',
        width: '100%',
        color: theme.palette.colorNeutral80,
        fontSize: '13px',
        display: 'flex',
        textDecoration: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '600',
        borderBottom: `2px solid ${theme.palette.colorPrimary}`,
        cursor: 'pointer',
        '& span': {
            verticalAlign: 'top',
            display: 'inline-block',
        },
    },
    prefixIcon: {
        width: '23px',
        height: '23px',
        lineHeight: '16px',
        fontSize: '16px',
        margin: '0 8px 0 10px',
        borderRadius: '50%',
        padding: '2px 6px 5px 2px',
        display: 'inline-block',
        backgroundColor: theme.palette.primaryButton,
    },
    filledCheckMark: {
        color: theme.palette.white,
        fontSize: '18px',
    },
    prefixNumber: {
        backgroundColor: theme.palette.colorPrimary,
        color: theme.palette.white,
        width: '23px',
        height: '24px',
        lineHeight: '16px',
        fontSize: '16px',
        margin: '0 8px 0 10px',
        borderRadius: '50%',
        padding: '5px',
        display: 'inline-block',
    },
});

const BreadcrumbMobile = ({
    classes, active, orderId,
    continueToPayment, continueToReview, dataDictionary,
}) => {
    const getPrefix = (index, isIcon) => (
        <span className={isIcon ? classes.prefixIcon : classes.prefixNumber}>
            {isIcon ? <CheckIcon className={classes.filledCheckMark} /> : index + 1}
        </span>
    );

    return (
        <Grid container className={classes.breadcrumbRow}>
            <Grid item xs={5} align="center">
                <Link
                    className={['shipping', 'shipping-date'].includes(active) ? classes.active : classes.inactive}
                    to={(continueToPayment ? `/checkout/shipping/${orderId}` : '#')}
                    data-test="checkout-breadcrumb-shipping"
                >
                    {getPrefix(0, continueToPayment)}
                    <span>{dataDictionary?.['Shipping'] || 'Shipping'}</span>
                </Link>
            </Grid>
            <Grid item xs={7} align="center">
                <Link
                    className={active === 'payment' ? classes.active : classes.inactive}
                    to={(continueToPayment || continueToReview ? `/checkout/payment/${orderId}` : '#')}
                >
                    {getPrefix(1, continueToReview)}
                    <span>{`${dataDictionary?.['Payment'] || 'Payment'} & ${dataDictionary?.['Review'] || 'Review'}`}</span>
                </Link>
            </Grid>
        </Grid>
    );
};

BreadcrumbMobile.propTypes = {
    classes: object.isRequired,
    active: string.isRequired,
    orderId: string.isRequired,
    continueToPayment: bool.isRequired,
    continueToReview: bool.isRequired,
    dataDictionary: object,
};

BreadcrumbMobile.defaultProps = {
    dataDictionary: {},
};

const mapStateToProps = (state) => ({
    orderId: commonSelectors.getOrderId(state),
    orderItems: commonSelectors.getRecipientsExcludePassport(state),
    continueToPayment: commonSelectors.continueToPayment(state),
    continueToReview: commonSelectors.getReviewOrderStatus(state),
    dataDictionary: getDataDictionary(state),
});

const mapDispatchToProps = (dispatch) => ({
    triggerValidateOrder: bindActionCreators(recipientActions.callToTriggerValidateOrder, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BreadcrumbMobile));
